module.exports = __webpack_public_path__ + "static/media/product_big_img.c87229d6.jpg";